import { extractGraphQLErrorCode } from "@/lib/extract-graphql-error-code";
import { isInvalidDateRangeCode } from "@ark/shared";

export function isInvalidDateRangeError(error: unknown): boolean {
  return isInvalidDateRangeCode(extractGraphQLErrorCode(error));
}
